import { render, staticRenderFns } from "./ErrorMsg.vue?vue&type=template&id=ae94d6a8&scoped=true&"
import script from "./ErrorMsg.vue?vue&type=script&lang=js&"
export * from "./ErrorMsg.vue?vue&type=script&lang=js&"
import style0 from "./ErrorMsg.vue?vue&type=style&index=0&id=ae94d6a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae94d6a8",
  null
  
)

export default component.exports